/**
 * Path: src/plugins/pinia.ts
 * Task: Creates and exports the Pinia store instance for state management.
 */

import { createPinia } from 'pinia';
export default createPinia();
